import React from 'react';

import { logout } from '../../libs/auth';
import Storage from '../../libs/storage';
import WithRouter from '../modules/foundation/components/WithRouter/WithRouter';

class TokenValidator extends React.Component {
  componentDidMount() {
    this.timerId = this.willTokenExpireSoon();
  }

  componentWillUnmount() {
    clearInterval(this.timerId);
  }

  // eslint-disable-next-line class-methods-use-this
  willTokenExpireSoon = () => {
    return setInterval(async () => {
      const expirationSeconds = Storage.tokenExpirationSeconds();

      if (expirationSeconds < Storage.SECONDS_FOR_NOTIFICATION) {
        await logout();
      }
    }, 2000);
  };

  render() {
    return null;
  }
}

export default WithRouter(TokenValidator);
